import actionTypes from '../actionTypes';

export function requestChangeMemberStatus({ memberId, doAccept }) {
  return {
    type: actionTypes.CHANGE_MEMBER_STATUS_REQUEST,
    memberId,
    doAccept
  };
}
export function successChangeMemberStatus() {
  return {
    type: actionTypes.CHANGE_MEMBER_STATUS_SUCCESS
  };
}

export function removeMemberRequest({ memberId }) {
  return {
    type: actionTypes.REMOVE_MEMBER_REQUEST,
    memberId
  };
}

export function removeMemberSuccess() {
  return {
    type: actionTypes.REMOVE_MEMBER_SUCCESS
  };
}

export function removeMemberFailure({}) {
  return {
    type: actionTypes.REMOVE_MEMBER_FAILURE
  };
}

export function quitMemberClubRequest(history) {
  return {
    type: actionTypes.QUIT_MEMBER_CLUB_REQUEST,
    history
  };
}

export function quitMemberClubSuccess() {
  return {
    type: actionTypes.QUIT_MEMBER_CLUB_SUCCESS    
  };
}

export const agentDetailsRequest = (agentId, dateFrom, dateTo) => ({
  type: actionTypes.AGENT_DETAILS_REQUEST,
  agentId,
  dateFrom,
  dateTo,
});

export const agentDetailsSuccess = (agentId, data) => ({
  type: actionTypes.AGENT_DETAILS_SUCCESS,
  agentId,
  data,
});

export const agentDetailsFailure = (agentId, e) => ({
  type: actionTypes.AGENT_DETAILS_FAILURE,
  agentId,
  exception: e,
});

export const memberDetailsRequest = (accountId, dateFrom, dateTo) => ({
  type: actionTypes.MEMBER_DETAILS_REQUEST,
  accountId,
  dateFrom,
  dateTo,
});

export const memberDetailsSuccess = (accountId, data) => ({
  type: actionTypes.MEMBER_DETAILS_SUCCESS,
  accountId,
  data,
});

export const memberDetailsFailure = (accountId, e) => ({
  type: actionTypes.MEMBER_DETAILS_FAILURE,
  accountId,
  exception: e,
});